import axios from 'axios';

const authClient = axios.create({
    baseURL: process.env.VUE_APP_AUTH_URL,
    headers: {
        "Content-Type": "application/json",
    }
});

export default authClient;